import $ from 'jquery';

const caseStudyInit = () => {
    const $component = $('.s-case-study');
    const $tiles = $component.find('.c-tile');
    const $loadMoreButton = $component.find('#load-more');
    const initialTilesToShow = 3;
    const nextTilesToShow = 3;
    let currentIndex = 0;

    // Split the tiles to reduce the number by three each time the button is clicked
    function showTiles(number) {
        // eslint-disable-next-line no-plusplus
        for (let i = currentIndex; i < currentIndex + number && i < $tiles.length; i++) {
            $($tiles[i]).addClass('visible');
        }
        currentIndex += number;
        if (currentIndex >= $tiles.length) {
            $loadMoreButton.hide();
        }
    }

    $loadMoreButton.on('click', () => { showTiles(nextTilesToShow); });

    // Initially show the first set of tiles
    showTiles(initialTilesToShow);
};

$(() => {
    caseStudyInit();
});



// WEBPACK FOOTER //
// ./src/sections/case-study/s-case-study.js